module.exports = __webpack_public_path__ + "static/media/_pdf-prueba.27708804.pdf";